<template>
    <div class="basic_wrap">
        <div class="page_header">
            <div class="header_inner">
                <div class="back_left" @click="$router.back()"></div>
                <div class="big_tit">我的余额</div>
            </div>
        </div>
        <div class="content_box">
            <div class="balance_card">
                <p class="balance_label">商城可用余额(元)</p>
                <p class="balance_num numberFont"><span>¥</span>{{ data.money || '0.00' }}</p>
                <!-- <div class="recharge_btn" @click="$router.push('/recharge')">充 值</div> -->
            </div>
            <div class="funds_box">
                <div class="funds_tit">资金流水</div>
                <template v-if="data.list && data.list.length">
                    <div class="funds_item" v-for="(v, k) in data.list" :key="k">
                        <div class="f_left">
                            <p class="f_reason">{{ v.reason }}</p>
                            <p class="f_time">{{ v.time }}</p>
                        </div>
                        <p class="f_money" :class="v.type == '1' ? 'in' : 'out'">{{ v.type == '1' ? '+' : '-' }}{{ v.money }}</p>
                    </div>
                </template>
                <div class="funds_empty" v-else>暂无资金流水</div>
            </div>
        </div>
    </div>
</template>

<script>

    import Fetch from '../../utils/fetch';
    export default {
        name: "funds",
        data() {
            return {
                data: {},
            };
        },
        created() {
            this.$parent.footer('user');
        },
        mounted() {
            this.start();
        },
        methods: {
            start() {
                Fetch('/user/funds').then((r) => {
                    this.data = r.data;
                });
            },
        }
    };
</script>

<style lang="less" scoped>
    .basic_wrap {
        padding-top: 60px;
        min-height: 100vh;
        background: #F6F7FB;
    }

    .page_header {
        position: fixed;
        top: 0;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        max-width: 500px;
        z-index: 20;
        background: url(../../assets/images/red_bg.png) no-repeat center center;
        background-size: 100% 100%;
    }

    .header_inner {
        position: relative;
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .back_left {
        position: absolute;
        left: 0;
        top: 14px;
        transform: translateY(-50%);
        width: 20px;
        height: 20px;
        background: url(../images/item/back.png) no-repeat center center;
        background-size: auto 100%;
    }

    .big_tit {
        font-size: 17px;
        font-weight: 600;
        color: #FFFFFF;
    }

    .content_box {
        width: 100%;
        max-width: 500px;
        margin: 0 auto;
        padding: 12px 12px 30px;
        box-sizing: border-box;
    }

    .balance_card {
        background: #fff;
        border-radius: 9px;
        padding: 22px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        box-shadow: 0 2px 9px 2px rgba(160, 160, 160, .15);
    }

    .balance_card .balance_label {
        font-size: 13px;
        color: #999;
        line-height: 18px;
        margin-bottom: 10px;
    }

    .balance_card .balance_num {
        font-size: 38px;
        font-weight: bold;
        color: #E96259;
        line-height: 48px;
    }

    .balance_card .balance_num span {
        font-size: 18px;
        margin-right: 4px;
    }

    .balance_card .recharge_btn {
        margin-top: 14px;
        width: 180px;
        height: 36px;
        line-height: 36px;
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #fff;
        background: linear-gradient(90deg, #E96259, #F5A623);
        border-radius: 18px;
    }

    .balance_card .recharge_btn:active {
        opacity: .85;
    }

    .funds_box {
        margin-top: 12px;
        background: #fff;
        border-radius: 9px;
        box-shadow: 0 2px 9px 2px rgba(160, 160, 160, .15);
        padding: 0 14px;
        overflow: hidden;
    }

    .funds_box .funds_tit {
        font-size: 14px;
        font-weight: bold;
        color: #333;
        line-height: 44px;
        border-bottom: 1px solid #F6F6F6;
    }

    .funds_box .funds_item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 0;
        border-bottom: 1px solid #F6F6F6;
    }

    .funds_box .funds_item:last-child {
        border-bottom: none;
    }

    .funds_item .f_left {
        flex: 1;
        min-width: 0;
    }

    .funds_item .f_reason {
        font-size: 14px;
        color: #333;
        line-height: 20px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

    .funds_item .f_time {
        font-size: 12px;
        color: #999;
        line-height: 17px;
        margin-top: 6px;
    }

    .funds_item .f_money {
        font-size: 18px;
        font-weight: bold;
        margin-left: 12px;
        white-space: nowrap;
    }

    .funds_item .f_money.in {
        color: #3FAF3E;
    }

    .funds_item .f_money.out {
        color: #E96259;
    }

    .funds_box .funds_empty {
        text-align: center;
        color: #999;
        font-size: 13px;
        padding: 40px 0;
    }
</style>
